export const NATIVE_TOKEN = "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE";

export const isNativeToken = (addr) =>
  !!addr && addr.toLowerCase() === NATIVE_TOKEN.toLowerCase();

export const PAYMENT_OPTIONS = [
  { mode: "usdc", label: "USDC", hint: "Stablecoin, $1 = 1 USDC" },
  { mode: "kub", label: "KUB", hint: "Native coin, value floats" },
];
